package floris.graphics.models.domain.models

import floris.graphics.models.dto.requests.MediaFileDto
import org.w3c.dom.url.URL

data class MediaFile(
    val id: String = "",
    val url: URL = URL(""),
    val mimeType: String = ""
)

fun MediaFile.toDto() = MediaFileDto(
    id = this.id,
    url = this.url.toString(),
    mimeType = this.mimeType
)

fun MediaFileDto.toMediaFile() = MediaFile(
    id = this.id,
    url = this.url.let(::URL),
    mimeType = this.mimeType
)